import { interfaces } from 'inversify';
import { ICanPublishProjectResponse } from '../projectDetails.models';

export interface IProjectDetailsSubmodule {
  initialize(): void;
  cleanup(): void;
  validate(): void;
  getValidationErrors(): string[];
  handleCanPublishCheck(response: ICanPublishProjectResponse): void;
}

export namespace IProjectDetailsSubmodule {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsSubmodule> = Symbol('PROJECT_DETAILS_SUBMODULE');
}
